import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import { handleLongText } from "../../config/global";
import { setLoading } from "../../core/feature/config/configSlice";
import { setLanguage } from "../../core/feature/language/languageSlice";
import { setToken } from "../../core/feature/token/tokenSlice";
import { setUser } from "../../core/feature/user/userSlice";
import { credentialCheck } from "../../core/service/api";
import { comboStudentsClass } from "../../core/service/api_pickup_student";
import { i18n } from "../../translations/i18n";
const PickupStudentMobile = (props: any) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isScanOpen, setIsScanOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isScan, setIsScan] = useState(false);
  const [students, setStudents] = useState<any>([]);
  const [isToken, setIsToken] = useState<any>(false);
  const { t } = useTranslation();
  const [studentId, setStudentId] = useState("");
  const [studentClass, setStudentClass] = useState("");
  const [studentName, setStudentName] = useState("");

  useEffect(() => {
    try {
      if (location.pathname.split("/")[2] != undefined) {
        setIsToken(true);
        dispatch(setToken(location.pathname.split("/")[2]));
        credentialCheck().then((resCredential) => {
          dispatch(setUser(resCredential.data.user));
        });
        if (location.pathname.split("/")[3] != undefined) {
          var lang = location.pathname.split("/")[3];
          i18n.changeLanguage(lang);
          dispatch(setLanguage(lang));
        }
      }
    } catch (error) {}
  }, [location.pathname.split("/")[2]]);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal(type: string) {
    setIsScan(type == "scan");
    setIsScanOpen(true);
    setIsOpen(false);
  }

  function closeScanModal() {
    setIsScanOpen(false);
  }

  function openScanModal() {
    setIsScanOpen(true);
  }

  const handleRefresh = async () => {};

  const getComboStudent = async () => {
    let query = [];
    query.push(`student_class=`);
    dispatch(setLoading(true));
    let response = await comboStudentsClass(query);
    setStudents(response.data);
    dispatch(setLoading(false));
  };

  const changeStudent = (id: any) => {
    setStudentId(id);
    setStudentClass(
      students.find((item: any) => item.student_id == id)?.student_class
    );
    setStudentName(
      students.find((item: any) => item.student_id == id)?.student_name
    );
  };

  useEffect(() => {
    getComboStudent();
  }, []);

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div className="text-left h-[calc(100vh-136px)]  px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
            <section className="mt-5 w-full h-full">
              <div className="flex flex-col justify-start h-full w-full">
                <div className="flex flex-col gap-3 justify-center w-full">
                  <div
                    onClick={() => setIsOpen(true)}
                    className="flex gap-2 w-full h-24 justify-start px-10 items-center bg-white rounded-xl cursor-pointer"
                  >
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 4.5H7.5C6.70435 4.5 5.94129 4.81607 5.37868 5.37868C4.81607 5.94129 4.5 6.70435 4.5 7.5V12M31.5 12V7.5C31.5 6.70435 31.1839 5.94129 30.6213 5.37868C30.0587 4.81607 29.2956 4.5 28.5 4.5H24M24 31.5H28.5C29.2956 31.5 30.0587 31.1839 30.6213 30.6213C31.1839 30.0587 31.5 29.2956 31.5 28.5V24M4.5 24V28.5C4.5 29.2956 4.81607 30.0587 5.37868 30.6213C5.94129 31.1839 6.70435 31.5 7.5 31.5H12"
                        stroke="#0054E6"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <span className="text-sm">Scan Kode QR / Buat Kode QR</span>
                  </div>
                  <div
                    onClick={props.toBookingPage}
                    className="flex gap-2 w-full h-24 justify-start px-10 items-center bg-white rounded-xl cursor-pointer"
                  >
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.4"
                        d="M31.6515 14.3818H29.8469V12.6174C29.8469 11.8642 29.2428 11.25 28.4985 11.25C27.7556 11.25 27.15 11.8642 27.15 12.6174V14.3818H25.3485C24.6041 14.3818 24 14.996 24 15.7492C24 16.5025 24.6041 17.1166 25.3485 17.1166H27.15V18.8826C27.15 19.6358 27.7556 20.25 28.4985 20.25C29.2428 20.25 29.8469 19.6358 29.8469 18.8826V17.1166H31.6515C32.3943 17.1166 33 16.5025 33 15.7492C33 14.996 32.3943 14.3818 31.6515 14.3818Z"
                        fill="#0054E6"
                      />
                      <path
                        d="M14.25 22.5232C8.18134 22.5232 3 23.4934 3 27.3698C3 31.2447 8.14981 32.2499 14.25 32.2499C20.3172 32.2499 25.5 31.2797 25.5 27.4033C25.5 23.5269 20.3502 22.5232 14.25 22.5232Z"
                        fill="#0054E6"
                      />
                      <path
                        opacity="0.4"
                        d="M14.25 18.8313C18.3818 18.8313 21.6939 15.4765 21.6939 11.2914C21.6939 7.1063 18.3818 3.75 14.25 3.75C10.1181 3.75 6.80605 7.1063 6.80605 11.2914C6.80605 15.4765 10.1181 18.8313 14.25 18.8313Z"
                        fill="#0054E6"
                      />
                    </svg>

                    <span className="text-sm">Buat Booking Penjemputan</span>
                  </div>
                  <div
                    onClick={props.toStatusBookingPage}
                    className="flex gap-2 w-full h-24 justify-start px-10 items-center bg-white rounded-xl cursor-pointer"
                  >
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.25 22.5232C8.18134 22.5232 3 23.4934 3 27.3698C3 31.2447 8.14981 32.2499 14.25 32.2499C20.3172 32.2499 25.5 31.2797 25.5 27.4033C25.5 23.5269 20.3502 22.5232 14.25 22.5232Z"
                        fill="#00A29C"
                      />
                      <path
                        opacity="0.4"
                        d="M14.25 18.8313C18.3818 18.8313 21.6939 15.4765 21.6939 11.2914C21.6939 7.1063 18.3818 3.75 14.25 3.75C10.1181 3.75 6.80605 7.1063 6.80605 11.2914C6.80605 15.4765 10.1181 18.8313 14.25 18.8313Z"
                        fill="#00A29C"
                      />
                      <path
                        opacity="0.4"
                        d="M28 12C30.2203 12 32 10.2204 32 8.0004C32 5.78038 30.2203 4 28 4C25.7797 4 24 5.78038 24 8.0004C24 10.2204 25.7797 12 28 12Z"
                        fill="#00A29C"
                      />
                    </svg>

                    <span className="text-sm">Status Booking Penjemputan</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </PullToRefresh>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-2 text-center w-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-2 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div className="flex flex-row">
                      Scan Kode QR / Buat Kode QR
                    </div>
                  </Dialog.Title>
                  <div className="rounded-2xl bg-psp-primary mt-3 p-2 flex flex-col gap-2">
                    <button
                      type="button"
                      onClick={() => {
                        openModal("scan");
                      }}
                      className=" bg-[#0054E6] py-2 px-3 font-bold text-white rounded-xl "
                    >
                      Scan Kode QR
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        openModal("create");
                      }}
                      className=" bg-[#0054E6] py-2 px-3 font-bold text-white rounded-xl "
                    >
                      Buat Kode QR
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={isScanOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeScanModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-2 text-center w-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-2 text-left align-middle shadow-xl transition-all justify-center">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900 flex justify-center"
                  >
                    <div className="flex flex-row">
                      {isScan ? "Scan Kode QR" : "Buat Kode QR"}
                    </div>
                  </Dialog.Title>

                  <form className="pt-3 w-full">
                    <label className="text-lg">Pilih Siswa</label>
                    <br />
                    <select
                      // disabled={!grade}
                      value={studentId}
                      onChange={(e) => changeStudent(e.target.value)}
                      className="py-3 px-3 w-full border rounded-lg disabled:text-gray-500"
                    >
                      <option disabled value="">
                        pilih
                      </option>
                      ;
                      {students.map((el: any) => {
                        return (
                          <option
                            value={el.student_id}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span className="w-32 flex items-center">
                              {`${el.student_nis} - ${
                                el.student_class
                              } - ${handleLongText(el.student_name, 20)}`}
                            </span>
                          </option>
                        );
                      })}
                    </select>
                  </form>
                  <br />
                  <button
                    type="button"
                    disabled={!studentId}
                    onClick={() => {
                      isScan
                        ? props.toScanPage(studentId, studentClass)
                        : props.toQRPage(studentId, studentClass, studentName);
                    }}
                    className={`w-full   ${
                      studentId ? "bg-[#0054E6]" : "bg-[#727272]"
                    } py-2 px-3 font-bold text-white rounded-xl `}
                  >
                    {isScan ? "Scan Kode QR" : "Buat Kode QR"}
                  </button>
                  {/* <div className="rounded-2xl bg-psp-primary mt-3 p-2 flex flex-col gap-2">
                    {students.map((item: any, index: number) => (
                      <div
                        onClick={() => {
                          props.toScanPage(item.student_id, item.student_class);
                        }}
                        className="text-sm flex bg-slate-200 rounded-xl p-2"
                        key={index}
                      >
                        <span className="w-32 flex items-center">
                          {item.student_nis}
                        </span>
                        <span className="flex flex-col">
                          <span>{handleLongText(item.student_name, 20)}</span>
                          <span>{item.student_class}</span>
                        </span>
                      </div>
                    ))}
                  </div> */}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default PickupStudentMobile;
